import styled from 'styled-components';

import { TextBodySmallCSS } from '../text/text.styled';
import { AlertType, typeMap } from '.';

interface IAlertStyledProps {
    type: AlertType;
    inline?: boolean;
}

const AlertStyled = styled.div<IAlertStyledProps>`
    ${TextBodySmallCSS}
    background: ${({ type, theme }) => theme.color[typeMap[type].background]};
    color: ${({ type, theme }) => theme.color[typeMap[type].text]};

    padding: ${({ theme }) => `${theme.spacing.XXS} ${theme.spacing.S}`};
    border-radius: ${({ theme }) => theme.borderRadius.S};

    display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};

    > svg {
        margin-right: ${({ theme }) => theme.borderRadius.S};
        flex-shrink: 0;
    }

    ${({ onClick }) => (onClick ? 'cursor: pointer' : '')};

    align-items: center;

    & strong {
        font-weight: bold;
    }
`;

// eslint-disable-next-line import/no-default-export
export default {
    AlertStyled,
};
